import { useSelector } from "react-redux";
import { Grid, TextField } from "@material-ui/core";
import React from "react";

export const FormImei = ({
  imei = "",
  loading=false,
  onChange = () => {},
}) => {

  return (
    <>
      <Grid item xs={12}>
        <TextField
          type="text"
          label="IMEI"
          name="imei"
          value={imei}
          onChange={(e) => {
            // Only allow letters and numbers with max length of 21
            const alphanumericValue = e.target.value.replace(
              /[^a-zA-Z0-9]/g,
              ""
            ).slice(0, 21);
            onChange({
              ...e,
              target: {
                ...e.target,
                value: alphanumericValue,
                name: e.target.name,
              },
            });
          }}
          fullWidth
          variant="outlined"
          disabled={loading}
          inputProps={{
            style: { textAlign: 'center' }
          }}
        />
      </Grid>
      {/* <SubmitBtns onClose={onClose} onSubmit={handleSubmit} loading={isLoadingComp?.loadingConfigEdit}/> */}
    </>
  );
};
